export const GOLDEN_CHIPS = 'goldenchips';
